import rootSetters from '../actions';

export const openSingleModal =
  (field: keyof ModalState['single']) => (dispatch: DispatchType) => {
    const {
      modal: { setModal },
    } = rootSetters(dispatch);
    setModal(`single.${field}`, true);
  };

export const closeSingleModal =
  (field: keyof ModalState['single']) => (dispatch: DispatchType) => {
    const {
      modal: { setModal },
    } = rootSetters(dispatch);
    setModal(`single.${field}`, false);
  };

const modalActionCreators = (dispatch: <T>(action: any) => T) =>
  Object.assign(
    {},
    {
      openSingleModal: (field: SingleModalField) =>
        dispatch<void>(openSingleModal(field)),
      closeSingleModal: (field: SingleModalField) =>
        dispatch<void>(closeSingleModal(field)),
    },
  );

export default modalActionCreators;
